import { ApprovalAuditLog } from "js/jsx/src/classes/admin/Approvals/ApprovalAuditLog.jsx";
import { DialogManager } from "js/jsx/src/classes/dialog.jsx";

export default function approvalauditlog() {
    var loadApprovalAuditLogPage = function () {
        quosal.ui.react.render(<DialogManager />, document.getElementById('dialogManager'));
        quosal.ui.react.render(<ApprovalAuditLog />, document.getElementById('currentDocument'));
        $('#pageName').val('approvalauditlog.quosalweb');
    };
    quosal.sell.modules.onAfterLoad.unbind().bind(loadApprovalAuditLogPage);
}
